import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const _ = require('lodash');
const generateSchema = require("generate-schema");

@Injectable()
export class JsonComponentService { 

  constructor(private http: HttpClient){

  }
  
  generateSchema(json){
    if (!json) return {};
    //schema generator doesn't handle nested array of different types
    //so as work around, flatten everything into a table, then annotate the json so last element has sum of fields

    let map = {};
    let copy = _.cloneDeep(json);
    proc(copy,map);
    function proc(e,currentMap){
      if (Array.isArray(e)) {
        Object.defineProperty(currentMap, "__type__", {value: "array" });
        currentMap.__arr__ = currentMap.__arr__ || {};
        for (let i=0;i<e.length;i++){
          proc(e[i],currentMap.__arr__);
        }
      } else if (typeof e == "object") {
        Object.defineProperty(currentMap, "__type__", {value: "object" });
        for (let key in e){
          currentMap[key] = currentMap[key] || {};
          proc(e[key],currentMap[key]);
        }
      } else {
        currentMap.__sample__ = e;
      }
    }


    fill(copy, map);
    function fill(e,currentMap){

      if (currentMap.__type__ == "array") {
        if (!e.length) {
          let def = currentMap.__arr__;
          e.push(def.__type__ == "object" ? {} : def.__type__ == "array" ? [] : def.__sample__);
        }
        fill(e[e.length-1],currentMap.__arr__);
      } else if (currentMap.__type__ ==  "object") {
        for (let key in currentMap){
          let def = currentMap[key];
          e[key] = e[key] || (def.__type__ == "object" ? {} : def.__type__ == "array" ? [] : def.__sample__);
          fill(e[key],def);
        }
      }
    }

    return generateSchema.json(copy);
  }
}


// WEBPACK FOOTER //
// ./src/common/json/json-component.service.ts